interface IGenericObject {
    [key: string]: any;
}

export const isEmptyObject = (object: IGenericObject) => !Object.keys(object).length;

export const isValidArray = (array: any): boolean => Array.isArray(array);
export const isEmptyArray = (array: any): boolean => isValidArray(array) && array.length === 0;
export const isNotEmptyArray = (array: any): boolean => isValidArray(array) && array.length > 0;

export function isNotNull<T>(v: T | null | undefined): v is T {
    return v !== null;
}